import cn from 'clsx'
import s from './ProductVariant.module.scss'
import { FC, useState } from 'react'
import { Text, CustomImage, Container, Button } from '@components/ui'

import { Product } from '@commerce/types/product'
import Image from 'next/image'
import { ProductSlider } from '@components/product'
import { LoreThreePageProductDetailsInner } from '@generated/model/loreThreePageProductDetailsInner'
import { LoreThreePageProductDetailsInnerVariantsInner } from '@generated/model/loreThreePageProductDetailsInnerVariantsInner'
import Link from 'next/link'

type ProductVariantProps = {
  product: Product | undefined
  detail: LoreThreePageProductDetailsInner
  variant: LoreThreePageProductDetailsInnerVariantsInner
}

// NEED TO CHANGE THIS TO VARIANTS
const ProductVariant: FC<ProductVariantProps> = ({
  product,
  variant,
  detail,
}) => {
  const [currentSlide, setCurrentSlide] = useState(0)

  const handleClick = (index: number) => {
    setCurrentSlide(index)
  }
  if (!variant) return null

  return (
    <>
      <div className={cn(s.root)} data-variant={variant.primary_color}>
        <div className={s.imagesContainer}>
          {variant.images && (
            <ProductSlider
              disabledOnDesktop={false}
              currentSlide={currentSlide}
              showNavigation={false}
            >
              {variant.images
                ?.filter((image) => image.image)
                .map((image, index) => (
                  <div key={`image-${index}`} className={s.imageContainer}>
                    <Image
                      src={image.image as unknown as string}
                      alt={'Product Image'}
                      className={s.image}
                      width={image.image_width}
                      height={image.image_height}
                      objectFit="contain"
                    />
                  </div>
                ))}
              <></>
            </ProductSlider>
          )}
          <div className={s.colorCircles}>
            {variant.images?.map((image, index) => (
              <div
                key={`color-circle-${index}`}
                className={s.colorCircle}
                style={{ background: image.hex_color }}
              />
            ))}
          </div>
        </div>
        <div className={s.details}>
          <div className={s.toplineContainer}>
            <div className={s.icon}>
              <Image
                src={detail.icon as string}
                alt={detail.title}
                width={detail.icon_width}
                height={detail.icon_height}
              />
            </div>
            <Text className={s.topline} variant="smallTextSmall">
              {variant.byline_title}
            </Text>
            <Text className={s.topline} variant="smallTextSmall">
              {variant.byline_detail}
            </Text>
          </div>
          <Text className={s.title} variant="headingLarge">
            {variant.title}
          </Text>
          <Text className={s.detail} html={variant?.detail} />

          <div className={s.priceContainer}>
            <Text className={s.price} variant="sectionHeading">
              $
              {product?.variants
                .find(
                  (productVariant) => productVariant.id == variant.variant_id
                )
                ?.prices.price.value?.toString()}
            </Text>

            <div className={s.buttons}>
              <Button className={s.button}>
                {variant.learn_more_link && (
                  <Link href={variant.learn_more_link}>
                    <a className={s.buttonInner}>Learn more</a>
                  </Link>
                )}
              </Button>
              <Button className={s.button}>
                {variant.order_link && (
                  <Link href={variant.order_link}>
                    <a className={s.buttonInner}>Order</a>
                  </Link>
                )}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default ProductVariant
